import { gql, TypedDocumentNode } from "@apollo/client";

import {
  AwsIntegration,
  MutationAwsIntegrationCreateArgs,
  MutationAwsIntegrationUpdateArgs,
} from "types/generated";

export const CREATE_AWS_INTEGRATION: TypedDocumentNode<
  {
    awsIntegrationCreate: Pick<AwsIntegration, "id">;
  },
  MutationAwsIntegrationCreateArgs
> = gql`
  mutation CreateAwsIntegration(
    $name: String!
    $roleArn: String!
    $generateCredentialsInWorker: Boolean!
    $autoattachEnabled: Boolean!
    $externalID: String
    $durationSeconds: Int
    $labels: [String!]!
    $space: ID
    $region: String
    $tagAssumeRole: Boolean
  ) {
    awsIntegrationCreate(
      name: $name
      roleArn: $roleArn
      generateCredentialsInWorker: $generateCredentialsInWorker
      autoattachEnabled: $autoattachEnabled
      externalID: $externalID
      durationSeconds: $durationSeconds
      labels: $labels
      space: $space
      region: $region
      tagAssumeRole: $tagAssumeRole
    ) {
      id
    }
  }
`;

export const UPDATE_AWS_INTEGRATION: TypedDocumentNode<
  {
    awsIntegrationUpdate: Pick<AwsIntegration, "id">;
  },
  MutationAwsIntegrationUpdateArgs
> = gql`
  mutation UpdateAwsIntegration(
    $id: ID!
    $name: String!
    $roleArn: String!
    $generateCredentialsInWorker: Boolean!
    $autoattachEnabled: Boolean!
    $externalID: String!
    $durationSeconds: Int!
    $labels: [String!]!
    $space: ID
    $region: String
    $tagAssumeRole: Boolean
  ) {
    awsIntegrationUpdate(
      id: $id
      name: $name
      roleArn: $roleArn
      generateCredentialsInWorker: $generateCredentialsInWorker
      autoattachEnabled: $autoattachEnabled
      externalID: $externalID
      durationSeconds: $durationSeconds
      labels: $labels
      space: $space
      region: $region
      tagAssumeRole: $tagAssumeRole
    ) {
      id
    }
  }
`;
